module.exports = __webpack_public_path__ + "img/13.078e496.png";